// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ProjectId
 */
export interface ProjectId {}

/**
 * Check if a given object implements the ProjectId interface.
 */
export function instanceOfProjectId(value: object): value is ProjectId {
  return true;
}

export function ProjectIdFromJSON(json: any): ProjectId {
  return ProjectIdFromJSONTyped(json, false);
}

export function ProjectIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectId {
  return json;
}

export function ProjectIdToJSON(json: any): ProjectId {
  return ProjectIdToJSONTyped(json, false);
}

export function ProjectIdToJSONTyped(
  value?: ProjectId | null,
  ignoreDiscriminator: boolean = false
): any {
  return value;
}
